import moment from 'moment'
export const isTodayCita = (fecha) =>{
    return moment().format('L') === moment(fecha, "YYYY-MM-DDTHH:mm:ss").format("L");
}